import queryString from "query-string";
import { isValidURL } from "./helpers";

// Toast Container Component
export function ToastContainer(Toasts = [], lifespan = 0) {
  // methods
  const mount = (wrapper) => {
    document.body.appendChild(wrapper);
    wrapper.classList.remove("hide-toast");
    wrapper.classList.add("show-toast");
  };
  const destroy = (wrapper) => {
    wrapper.classList.remove("show-toast");
    wrapper.classList.add("hide-toast");
    setTimeout(() => {
      document.body.removeChild(wrapper);
    }, 1000);
  };
  const ding = () => {
    const audio = new Audio(
      `${window.location.origin}/wp-content/uploads/2020/07/toast-chime.mp3`
    );
    audio.play();
  };

  // template
  const wrapper = document.createElement("div");
  wrapper.classList.add("toast-container", "hide-toast");
  Toasts.forEach((Toast) => wrapper.appendChild(Toast));

  // render
  mount(wrapper);

  // covert SVG images to inline for branding colors
  bodhisvgsInlineSupport();

  // ding (& self-destruct after lifespan)
  ding();
  setTimeout(() => destroy(wrapper), lifespan);
}

// Toast Component
export function Toast({ text, img, link, target, icon, redirect = false }) {
  // methods
  const destroy = (wrapper) => {
    wrapper.classList.add("hide-toast");
    setTimeout(() => {
      wrapper.parentElement.removeChild(wrapper);
    }, 500);
  };

  // template
  const wrapper = document.createElement("a");
  wrapper.classList.add("toast");
  if (link) {
    if (isValidURL(link)) {
      const linkURL = new URL(link);
      if (linkURL.pathname === location.pathname && linkURL.search) {
        //clip link on this page
        const { c } = queryString.parse(linkURL.search);
        if (c) {
          wrapper.classList.add("js-hero-swap");
          wrapper.dataset.clipId = c;
        }
      }
    }
    wrapper.href = link;
    wrapper.target = target;
  }
  wrapper.innerHTML = `
      <div class="toast-close">
        <svg width="10" height="10" viewBox="0 0 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.3002 1.96895L12.0312 0.699951L7.0002 5.73095L1.9692 0.699951L0.700195 1.96895L5.7312 6.99995L0.700195 12.031L1.9692 13.3L7.0002 8.26895L12.0312 13.3L13.3002 12.031L8.2692 6.99995L13.3002 1.96895Z" fill="currentColor"/>
        </svg>
      </div>
      ${
        img
          ? `<div class="toast-img"><img src="${img}" /></div>`
          : icon
          ? `<div class="toast-img">${icon}</div>`
          : ""
      }
      <div class="toast-message">
        <div class="ellipsis-box">
          <span>${text}</span>
        </div>
        ${redirect ? '<span class="redirect-counter"></span>' : ""}
      </div>
      <div class="toast-expand">

        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.51182 20.4894L3.51182 20.4894C8.20044 25.178 15.8022 25.178 20.4908 20.4894C25.1795 15.8008 25.1795 8.19901 20.4909 3.51041C15.8023 -1.17824 8.20047 -1.17826 3.51187 3.51036C3.51186 3.51037 3.51184 3.51039 3.51183 3.5104C-1.17071 8.20154 -1.17071 15.7983 3.51182 20.4894L3.51182 20.4894ZM11.3678 9.47036L7.85783 9.31936C7.30164 9.28886 6.86436 8.83234 6.85783 8.27536L6.85783 7.85636L6.85783 7.85638C6.85829 7.31348 7.29876 6.87375 7.84166 6.87421C7.84704 6.87421 7.85242 6.87426 7.8578 6.87436L15.9478 7.02636C16.5048 7.0433 16.9535 7.48856 16.9748 8.04536L17.1918 16.0654L17.1918 16.0654C17.2073 16.602 16.7848 17.0495 16.2482 17.065C16.2381 17.0652 16.2279 17.0654 16.2178 17.0654L15.8008 17.0654C15.242 17.0583 14.7823 16.623 14.7448 16.0654L14.5508 12.6174C14.5208 12.0674 14.1768 11.9364 13.7878 12.3254L9.18782 16.9254C8.79752 17.3161 8.16436 17.3165 7.77362 16.9261C7.77335 16.9259 7.77309 16.9256 7.77283 16.9254L7.07283 16.2254C6.68209 15.8351 6.68174 15.2019 7.07204 14.8111C7.0723 14.8109 7.07257 14.8106 7.07283 14.8104L11.6618 10.2244C12.0488 9.83236 11.9168 9.49436 11.3678 9.47036L11.3678 9.47036Z" fill="currentColor"/>
        </svg>
      </div>
    `;

  // events
  wrapper.querySelector(".toast-close").addEventListener("click", (e) => {
    e.preventDefault();
  });
  wrapper.addEventListener("click", (e) => {
    destroy(wrapper);
  });

  // return
  return wrapper;
}
